<div baCardBlur class="animated fadeIn card {{cardType}} {{baCardClass || ''}}" zoom-in>
    <div *ngIf="cardTitle" class="card-header clearfix">
        <h3 class="card-title" translate>{{cardTitle}}</h3>
    </div>
    <div class="card-body">
        <ng-content></ng-content>
    </div>
</div>
